import React from 'react'
// import YouTube from 'react-youtube'
import { YouTube } from 'react-youtube-lazyload'
import 'react-youtube-lazyload/dist/index.css'

export default function YoutubePlayer(args) {
  const opts = {
    height: '390',
    width: '640',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  }

  return (
    <div>
      <YouTube
        {...args}
        onPlay={() => {
          // setMute(0);
        }}
        // opts={opts}
        onReady={(event) => {
          event.target.pauseVideo()
        }}
      />
    </div>
  )
}
